export default __webpack_public_path__ + "static/media/logo-top20-vector.f703083d.svg";